import { DialogConfig } from '@agent-ds/shared/components/dialog/dialog-config';
import { DialogRef } from '@agent-ds/shared/components/dialog/dialog-ref';
import { DialogService, DynamicFieldService, JobApiService, StudentApiService } from '@agent-ds/shared/services';
import { Component, OnDestroy, OnInit } from '@angular/core';
// import { CounselingMemoUploadType as UploadType } from '@agent-ds/shared/enums';
import { Job, JobScreeningInfo, StudentDetail } from '@agent-ds/shared/interfaces';
import { DynamicField, FormMeta } from '@agent-ds/shared/models';
import { Subscription } from 'rxjs';
import { JobScreeningInfoTypes } from '@agent-ds/shared/interfaces';
// import { CounselingMemoConfirmDialogComponent } from '@agent-ds/student/components/counseling-memo-confirm-dialog/counseling-memo-confirm-dialog.component';
// import { SituationMemo, CounselingMemo } from '@agent-ds/shared/interfaces/memo';

@Component({
  selector: 'ag-job-screening-info-edit-dialog',
  templateUrl: './job-screening-info-edit-dialog.component.html',
  styleUrls: ['./job-screening-info-edit-dialog.component.scss'],
})
export class JobScreeningInfoEditDialogComponent implements OnInit, OnDestroy {
  constructor(
    private dialogService: DialogService,
    private dynamicService: DynamicFieldService,
    private jobApiService: JobApiService,
    public dialog: DialogRef,
    public config: DialogConfig<{ job: Job, jobScreeningInfoData: JobScreeningInfo; }>,
  ) {}

  saving: boolean = false;
  job: Job;
  jobScreeningInfoData: JobScreeningInfo;
  jobScreeningInfoDataModel: {
    jobScreeningInfo: JobScreeningInfo
  };
  jobScreeningInfo1Meta: FormMeta;
  jobScreeningInfo2Meta: FormMeta;
  private fieldSubscription: Subscription;

  ngOnInit() {
    this.job = this.config.data.job;
    this.jobScreeningInfoData = {
      ...this.config.data.jobScreeningInfoData
    };
    this.jobScreeningInfoDataModel = {
      jobScreeningInfo: this.jobScreeningInfoData
    }
    this.fieldSubscription = this.dynamicService.fieldUpdateEvent.subscribe(() => {
      this.initFieldsMeta();
    });
  }

  ngOnDestroy() {
    if(this.fieldSubscription) {
      this.fieldSubscription.unsubscribe();
      this.fieldSubscription = null;
    }
  }

  private initFieldsMeta() {
    this.jobScreeningInfo1Meta = {
      disabled: true,
      initTouched: true,
      groups: [
        {
          title: 'サブステータス情報',
          class: 'form__group--green-title-border',
          rows: [
            ...this.dynamicService.getFormRows(
              {
                fieldName: 'type',
                fieldType: 'list',
                label: '選考情報',
                displayType: 'dropdown',
                validationStyle: {
                  required: true,
                  options: [
                    ...Object.values(JobScreeningInfoTypes)
                  ],
                },
              },
              'jobScreeningInfo',
              'full',
            ),
          ]
        },
      ],
    };
    this.jobScreeningInfo2Meta = {
      disabled: false,
      initTouched: true,
      groups: [
        {
          class: 'form__group--green-title-border',
          rows: [
            ...this.dynamicService.getFormRows(
              {
                "model": "job",
                "fieldName": "jobScreeningInfo",
                "fieldType": "screening-info",
                "label": "サブステータス情報",
                "isCustomField": false,
                "displayType": "screening-info",
                "displayStyle": {},
                "isSearchable": false,
                "validationStyle": {},
                "searchStyle": {},
                "unit": ""
              }
            ),
          ],
        },
      ],
    };
  }

  public isValidJobScreeningInfoData(): boolean {
    return !!this.jobScreeningInfoData.type;
  }

  public close(): void {
    this.dialog.close();
  }

  public reflect(): void {
    if (
      !this.isValidJobScreeningInfoData() ||
      !this.job ||
      !this.job.id ||
      !this.jobScreeningInfoData.id
    ) {
      return;
    }

    if (this.saving) return;

    this.saving = true;

    // deadline を number|null に正規化（'' 混入対策）
    const payload: any = {
      ...this.jobScreeningInfoData,
      request1Deadline: this.toNullableInt((this.jobScreeningInfoData as any).request1Deadline),
      request2Deadline: this.toNullableInt((this.jobScreeningInfoData as any).request2Deadline),
      request3Deadline: this.toNullableInt((this.jobScreeningInfoData as any).request3Deadline),
    };

    this.jobApiService.updateJobScreeningInfo(this.job.id, payload).subscribe(
      () => {
        this.saving = false;
        this.dialog.close({ saved: true });
      },
      () => {
        this.saving = false;
      },
    );
  }

  /** 削除ボタン用 */
  public deleteJobScreeningInfo(): void {
    if (
      !this.isValidJobScreeningInfoData() ||
      !this.job ||
      !this.job.id ||
      !this.jobScreeningInfoData.id
    ) {
      return;
    }
    if (this.saving) return;

    // プロジェクト標準の confirm があれば差し替え推奨（今回は簡易 confirm）
    const ok = window.confirm('このサブステータス情報を削除しますか？');
    if (!ok) return;

    this.saving = true;

    this.jobApiService.deleteJobScreeningInfo(this.job.id, this.jobScreeningInfoData.id).subscribe(
      () => {
        this.saving = false;
        this.dialog.close({ deleted: true });
      },
      () => {
        this.saving = false;
      },
    );
  }

  private toNullableInt(v: any): number | null {
    if (v === '' || v === undefined || v === null) return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  }
}
